const formatMoney = (amount: number, locale: string = `en-GB`, currency: string = `GBP`): string => {
  const formattedAmount = new Intl.NumberFormat(locale, {
    style: `currency`,
    currency,
  }).format(amount > 0 ? amount : 0)

  return formattedAmount
}
export default formatMoney
